import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import { useFormik, Form, FormikProvider } from 'formik';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import { useNavigate } from 'react-router-dom';
// material
import { Stack, TextField, IconButton, InputAdornment, Container, FormGroup, FormControlLabel, Checkbox, InputLabel, Select, MenuItem, FormControl, Fade } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { useAuth } from '../components/common/use-auth';
import { useRouter } from '../components/common/use-router';
import { useTranslation } from 'react-i18next';

import Request from '../components/common/Request';
import {  Paths, GetAzurePath, AzurePaths } from '../components/common/Constants';

import {
    useParams
  } from "react-router-dom";
import Page from '../components/Page';

import { FormHelperText } from '@mui/material';
// ----------------------------------------------------------------------

export default function User() {
    const {t, i18n} = useTranslation();
        
    const [showPassword, setShowPassword] = useState(false);

    const router = useRouter();
    const navigate = useNavigate();
    const {user, signup, redirectUrl} = useAuth();
    
    const [serverError, setServerError] = useState(null);
    const [serverMessage, setServerMessage] = useState(null);
    const [showServerMessage, setShowServerMessage] = useState(false);
    const [lastTimeout, setLastTimeout] = useState(null);

    const [data, setData] = useState(null);
    let { id } = useParams();
    
  

    const RegisterSchema = Yup.object().shape({
        firstName: Yup.string(),//.min(2, 'Too Short!').max(50, 'Too Long!').required('First name required'),
        lastName: Yup.string(),//.min(2, 'Too Short!').max(50, 'Too Long!').required('Last name required'),
        email: Yup.string().email(t("user_email_not_valid")).required(t("user_email_required")),
        password: Yup.string(),//.required('Password is required'),
        userName: Yup.string().min(2, t("user_input_too_short")).max(50, t("user_input_too_long")).required(t("user_username_required")),
    });

    console.log(id);

    useEffect( async () => {
        var result = await Request.Get(Paths.GetUserById.replace("{id}", id));

        if (result.ok){
            console.log(result.data);
            setData(result.data);
            formik.setFieldValue("userName", result.data.Username, false);
            formik.setFieldValue("email", result.data.Email, false);
            formik.setFieldValue("firstName", result.data.FirstName, false);
            formik.setFieldValue("lastName", result.data.LastName, false);
            formik.setFieldValue("userRole", result.data.UserRole, false);

            formik.setFieldValue("getsNotifications", result.data.GetsNotifications, false);
            formik.setFieldValue("isVisibleToOthers", result.data.IsVisibleToOthers, false);
            formik.setFieldValue("ridesVisibleToPublic", result.data.RidesVisibleToPublic, false);
            formik.setFieldValue("enabled", result.data.Enabled, false);

        }

    }, []);


console.log(data);
    const formik = useFormik({
        initialValues: {
            userId : id,
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            userName : '',
            userRole : 0,
            getsNotifications : true,
            isVisibleToOthers : true,
            ridesVisibleToPublic : true,
            enabled : true
        },
        validationSchema: RegisterSchema,
        onSubmit: async (values) => {

          //  setServerError(null);
           // console.log(values);

            var response = await Request.Put( Paths.UpdateSpecificUser, values);

            //console.log("respnse", user);

            if (response.statusCode != 200){
               // console.log("serverError!!");

                setServerError(true);
                setServerMessage(t("user_update_failed"));
             
                if (response.statusCode == 409) {
                    setFieldError("userName", t("user_username_already_exists"));
                }
            }
            else
            {
                setServerError(false);
                setServerMessage(t("user_update_success"));
            }

            setShowServerMessage(true);

            if (lastTimeout != null){
                clearTimeout(lastTimeout);
            }

            var timeout = setTimeout(() => {
              setShowServerMessage(false);
            }, 4000);

            setLastTimeout(timeout);

        
        }
    });
    const { errors, touched, handleSubmit, isSubmitting, getFieldProps, setFieldError } = formik;

    return (
        
        <Page title={t("user_title_update_user")}>
            <Container>
                <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                    <Stack spacing={3}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <TextField
                        fullWidth
                        label={t("user_firstName")}
                        {...getFieldProps('firstName')}
                        error={Boolean(touched.firstName && errors.firstName)}
                        helperText={touched.firstName && errors.firstName}
                        />

                        <TextField
                        fullWidth
                        label={t("user_lastName")}
                        {...getFieldProps('lastName')}
                        error={Boolean(touched.lastName && errors.lastName)}
                        helperText={touched.lastName && errors.lastName}
                        />
                    </Stack>

                    <TextField
                        fullWidth
                        autoComplete="Username"
                        label={t("user_userName")}
                        {...getFieldProps('userName')}
                       // onChange={formik.handleChange}
                     //   value={formik.values.userName}
                        error={Boolean(touched.userName && errors.userName)}
                        helperText={touched.userName && errors.userName}
                    />

                    <TextField
                        fullWidth
                        autoComplete="email"
                        type="email"
                        label={t("user_email")}
                        {...getFieldProps('email')}
                        error={Boolean(touched.email && errors.email)}
                        helperText={touched.email && errors.email}
                    />





                    <FormGroup>
                        <FormControlLabel control={<Checkbox name="getsNotifications"  checked={formik.values.getsNotifications} onChange={formik.handleChange} />  } label={t("user_gets_notifications")} />
                        <FormControlLabel control={<Checkbox name="isVisibleToOthers"  checked={formik.values.isVisibleToOthers} onChange={formik.handleChange}  />} label={t("user_is_visible_to_others")} />
                        <FormControlLabel control={<Checkbox name="ridesVisibleToPublic"  checked={formik.values.ridesVisibleToPublic} onChange={formik.handleChange}   />} label={t("user_rides_visible_to_public")} />
                        <FormControlLabel control={<Checkbox name="enabled"  checked={formik.values.enabled} onChange={formik.handleChange}   />} label={t("user_enabled")} />
                    </FormGroup>


                    <FormControl fullWidth>
                        {/* <InputLabel id="demo-simple-select-label">userRole</InputLabel> */}
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            {...getFieldProps('userRole')}
                            label={t("user_userRole")}
                            onChange={formik.handleChange}
                        >
                            <MenuItem value={0}>{t("user_role_user")}</MenuItem>
                            <MenuItem value={8}>{t("user_role_admin")}</MenuItem>
                            <MenuItem value={16}>{t("user_role_super_admin")}</MenuItem>
                            <MenuItem value={32}>{t("user_role_ultra_admin")}</MenuItem>
                        </Select>
                    </FormControl>

                    <TextField
                        fullWidth
                        autoComplete="current-password"
                        type={showPassword ? 'text' : 'password'}
                        label={t("user_password")}
                        {...getFieldProps('password')}
                        InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                            <IconButton edge="end" onClick={() => setShowPassword((prev) => !prev)}>
                                <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                            </IconButton>
                            </InputAdornment>
                        )
                        }}
                        error={Boolean(touched.password && errors.password)}
                        helperText={touched.password && errors.password}
                    />

                    <LoadingButton
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                        loading={isSubmitting}>
                        {t("user_save")}
                    </LoadingButton>

                    <Fade in={showServerMessage === true} timeout={ {enter:1000, exit:1000 }}>
                        <div> 
                            <FormHelperText error={serverError}>{serverMessage}</FormHelperText>
                        </div>
                    </Fade>
                    

                    </Stack>
                </Form>
                </FormikProvider>
            </Container>
        </Page>
    );
}
